import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { WebSocketError, WebSocketState } from '../models';

@Injectable({
	providedIn: 'root'
})
export class SocketsManagerService {
	private sockets: WebSocketState[] = [];
	private readonly _sockets: Subject<WebSocketState[]> = new BehaviorSubject(this.sockets);
	private readonly sockets$: Observable<WebSocketState[]> = this._sockets.asObservable();

	private errors: WebSocketError[] = [];
	private readonly _errors: Subject<WebSocketError[]> = new BehaviorSubject(this.errors);
	private readonly errors$: Observable<WebSocketError[]> = this._errors.asObservable();

	public registerSocket(webSocketState: WebSocketState): void {
		const socketIndex: number = this.sockets.findIndex(x => x.name === webSocketState.name);
		if (socketIndex > -1) {
			this.sockets[socketIndex] = webSocketState;
			this._sockets.next(this.sockets);
			return;
		}

		this.sockets.push(webSocketState);
		this._sockets.next(this.sockets);
	}

	public getSockets$(): Observable<WebSocketState[]> {
		return this.sockets$;
	}

	public getErrors$(): Observable<WebSocketError[]> {
		return this.errors$;
	}

	public addError(error: WebSocketError): void {
		const errorIndex: number = this.errors.findIndex(x => x.webSocketState.name === error.webSocketState.name);
		if (errorIndex > -1) {
			this.errors[errorIndex] = error;
			this._errors.next(this.errors);
			return;
		}

		this.errors.push(error);
		this._errors.next(this.errors);
	}

	public removeError(webSocketName: string): void {
		this.errors = this.errors.filter((error: WebSocketError) => error.webSocketState.name !== webSocketName);
		this._errors.next(this.errors);
	}

	public removeAllErrors(): void {
		this.errors = [];
		this._errors.next(this.errors);
	}

	public unregisterAllSockets(): void {
		this.sockets = [];
		this._sockets.next(this.sockets);
	}
}
